__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "host";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@incoresoft/incoresoft-analytics-ui", "26.1.40-dev.0", () => (() => (__webpack_require__(4781))), 1);
			register("@incoresoft/incoresoft-charts-module", "26.1.17-dev.0", () => (() => (__webpack_require__(7689))), 1);
			register("@incoresoft/incoresoft-icons", "26.1.29-dev.0", () => (() => (__webpack_require__(3089))), 1);
			register("@incoresoft/incoresoft-licenses", "26.1.18-dev.0", () => (() => (__webpack_require__(1171))), 1);
			register("@incoresoft/incoresoft-logs", "26.1.19-dev.0", () => (() => (__webpack_require__(8777))), 1);
			register("@incoresoft/incoresoft-marketplace", "26.1.15-dev.0", () => (() => (__webpack_require__(8669))), 1);
			register("@incoresoft/incoresoft-monitoring", "26.1.27-dev.0", () => (() => (__webpack_require__(8011))), 1);
			register("@incoresoft/incoresoft-players", "26.1.210-dev.0", () => (() => (__webpack_require__(8829))), 1);
			register("@incoresoft/incoresoft-profile", "26.1.13-dev.0", () => (() => (__webpack_require__(3292))), 1);
			register("@incoresoft/incoresoft-settings-token", "26.1.11-dev.0", () => (() => (__webpack_require__(4117))), 1);
			register("@incoresoft/incoresoft-settings-updates", "26.1.14-dev.0", () => (() => (__webpack_require__(175))), 1);
			register("@incoresoft/incoresoft-storage-cleaner", "26.1.14-dev.0", () => (() => (__webpack_require__(2297))), 1);
			register("@incoresoft/incoresoft-toasts", "26.1.15-dev.0", () => (() => (__webpack_require__(2639))), 1);
			register("@incoresoft/incoresoft-trees", "26.1.13-dev.0", () => (() => (__webpack_require__(6545))), 1);
			register("@incoresoft/incoresoft-ui", "26.1.86-dev.0", () => (() => (__webpack_require__(1327))), 1);
			register("@incoresoft/incoresoft-users", "26.1.15-dev.0", () => (() => (__webpack_require__(3509))), 1);
			register("@incoresoft/incoresoft-vezha-logs", "26.1.11-dev.0", () => (() => (__webpack_require__(3283))), 1);
			register("pinia", "2.1.7", () => (() => (__webpack_require__(3109))), 1);
			register("vue-i18n", "10.0.8", () => (() => (__webpack_require__(4277))), 1);
			register("vue-i18n", "9.9.1", () => (() => (__webpack_require__(9550))), 1);
			register("vue-router", "4.6.4", () => (() => (__webpack_require__(7590))), 1);
			register("vue", "3.4.19", () => (() => (__webpack_require__(7560))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};